<template>
  <div>
    <div class="blocks">
      <div class="mobile-list">
        <div class="d-flex align-items-center justify-content-between mx-3 px-1">
          <div class="d-flex align-items-center">
            <span class="mod-icon-arrow-left mod-icon-back" @click="$router.back()" />
            <h2 class="ml-2">Totals</h2>
          </div>
          <div class="flex-grow-1 mr-3">
            <div class="input-group search w-100 ml-3">
              <button type="button" class="btn input-group-btn" @click="clearSearch">
                <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
              </button>
              <input class="form-control" type="text" v-model="q" @keyup="searchText($event)"
                     placeholder="Search"
              />
            </div>
          </div>
        </div>
        <div class="mt-3 border-bottom">
          <div class="d-flex align-items-center justify-content-between mx-3 px-1">
            <p class="text-secondary m-0">Statistics for {{ meta.total }} jobs</p>
            <div class="d-flex align-items-center mb-1">
              <button class="btn btn-primary btn-schedule btn-refine" @click="showFilters = true">
                <span v-if="!clearFiltersButtonShouldBeDisabled" class="mobile-dot-refine-active-filters" />
                REFINE
              </button>
              <button :class="[filters.deductedMoverWages ? 'btn-primary' : 'btn-secondary']" class="btn btn-refine btn-schedule ml-2" @click="setDeductedMoverWagesFilter(filters.deductedMoverWages === 1 ? 0 : 1)">
                $$
              </button>
              <button class="btn btn-primary ml-3" @click="downloadReport">
                Download report
              </button>
              <button class="btn btn-primary ml-3" v-if="$_can('clusters.totals.mark-as-paid')" @click="markAsPaid">
                Mark as paid
              </button>
              <button class="btn btn-secondary expand-all" @click="expanded = !expanded">
                <i :class="[expanded ? 'fa fa-compress' : 'fa fa-expand']" />
              </button>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center mt-4 pt-1 px-4">
          <a class="mobile-menu-link" :class="[mobileMenuState === 'stats' ? 'mobile-menu-link-active' : '']" href="" @click.prevent="mobileMenuState = 'stats'">Stats</a>
          <a class="mobile-menu-link" :class="[mobileMenuState === 'listOfJobs' ? 'mobile-menu-link-active' : '']" href="" @click.prevent="mobileMenuState = 'listOfJobs'">List of jobs</a>
        </div>

        <div v-if="mobileMenuState === 'listOfJobs'" class="list-jobs container-fluid m-0 mt-3">
          <div class="row">
            <div class="col-3" />
            <div class="col-3 text-center">
              <span class="total-table-title">Company Profit</span>
            </div>
            <div class="col-3 text-center">
              <span class="total-table-title">Cluster Profit</span>
            </div>
            <div class="col-3 text-center">
              <span class="total-table-title">Balance due</span>
            </div>
          </div>
          <TotalsBlockMobile v-for="total in totals" :key="total.id" :total="total" :expanded="expanded" @openSidebar="openSidebar(total)" />
          <div class="row blocks">
            <pagination class="col-sm-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
          </div>
        </div>

        <div v-if="mobileMenuState === 'stats'" class="container-fluid m-0 mt-3">
          <TotalsStatisticMobile :sums="sums" :averages="averages" />
        </div>
      </div>
      <div class="desktop-list">
        <div class="row pt-3 l-m-b-20 d-flex align-items-center">
          <div class="col-1">
            <h1>Totals</h1>
          </div>
          <div class="col-7 d-flex">
            <div class="input-group search">
              <button type="button" class="btn input-group-btn" @click="clearSearch">
                <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
              </button>
              <input class="form-control" type="text" v-model="q" @keyup="searchText($event)"
                     placeholder="Search"
              />
            </div>
            <button class="btn btn-primary ml-3" @click="downloadReport">
              Download report
            </button>
            <button class="btn btn-primary ml-3" v-if="$_can('clusters.totals.mark-as-paid')" @click="markAsPaid">
              Mark as paid
            </button>
          </div>
          <div class="col-4 d-flex align-items-center justify-content-end">
            <div class="row">
              <div class="col-6">
                <load-filter-dropdown
                  @filterSelected="loadFilters"
                  @filterTemplatesInitialized="setFilterTemplatesInitialized"
                  :route="$route.name"
                />
              </div>
              <div class="col-6">
                <button :class="[filters.deductedMoverWages ? 'btn-primary' : 'btn-secondary']" class="btn btn-refine btn-schedule" @click="setDeductedMoverWagesFilter(filters.deductedMoverWages === 1 ? 0 : 1)">
                  <template v-if="filters.deductedMoverWages">
                    Show profit with wages
                  </template>
                  <template v-else>
                    Show profit without wages
                  </template>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-11 filters-field">
            <span>Filters:</span>
            <span v-if="filtersLoaded">
              <span v-if="carriers && filters.carrier.length">
                <template v-for="carrier in filters.carrier">
                  <span v-if="carriers.find(el => el.id === carrier)" :key="carrier" class="filter-item btn btn-filter">
                    <span class="mod-icon-filter" @click="removeFilter('carrier', carrier)" />
                    Carrier: {{ carriers.find(el => el.id === carrier).name }}
                  </span>
                </template>
              </span>
              <span v-if="companies && filters.company.length">
                <template v-for="company in filters.company">
                  <span v-if="companies.find(el => el.id === company)" :key="company" class="filter-item btn btn-filter">
                    <span class="mod-icon-filter" @click="removeFilter('company', company)" />
                    Company: {{ companies.find(el => el.id === company).name }}
                  </span>
                </template>
              </span>
              <span v-if="filters.move_date" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('move_date')" />
                Move Date: {{ filters.move_date }}</span>
              <span v-if="filters.created_at" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('created_at')" />
                Booked Date: {{ filters.created_at }}</span>
              <span v-if="salesFilter && filters.clusterUser && filters.clusterUser.length">
                <template v-for="clusterUser in filters.clusterUser">
                  <span v-if="salesFilter.find(el => el.id === clusterUser)" :key="clusterUser" class="filter-item btn btn-filter">
                    <span class="mod-icon-filter" @click="removeFilter('clusterUser', clusterUser)" />
                    Sales: {{ salesFilter.find(el => el.id === clusterUser).full_name }}</span>
                </template>
              </span>
              <span v-if="salesFilter && filters.bookedByUser && filters.bookedByUser.length">
                <template v-for="bookedByUser in filters.bookedByUser">
                  <span v-if="salesFilter.find(el => el.id === bookedByUser)" :key="bookedByUser" class="filter-item btn btn-filter">
                    <span class="mod-icon-filter" @click="removeFilter('bookedByUser', bookedByUser)" />
                    Booked by: {{ salesFilter.find(el => el.id === bookedByUser).full_name }}</span>
                </template>
              </span>
              <template v-if="filters.userCompanies && clusterUsersFilter.length">
                <span v-if="clusterUsersFilter.find(el => el.id === filters.userCompanies)" class="filter-item btn btn-filter">
                  <span class="mod-icon-filter" @click="removeFilter('userCompanies')" />
                  User companies: {{ clusterUsersFilter.find(el => el.id === filters.userCompanies).full_name }}
                </span>
              </template>
              <span v-if="tags && filters.tags && filters.tags.length">
                <span v-for="tag in filters.tags" :key="tag" class="filter-item btn btn-filter">
                  <span class="mod-icon-filter" @click="removeFilter('tags', tag)" />
                  Tag: {{ tags.find(el => el.id === tag).name }} </span>
              </span>
              <span v-if="moverNumbers && filters.movers && filters.movers.length">
                <span v-for="mover in filters.movers" :key="mover" class="filter-item btn btn-filter">
                  <span class="mod-icon-filter" @click="removeFilter('movers', mover)" />
                  Number of movers: {{ mover }} </span>
              </span>
              <span v-if="filters.moveSizes && filters.moveSizes.length">
                <span v-for="moveSize in filters.moveSizes" :key="moveSize" class="filter-item btn btn-filter">
                  <span class="mod-icon-filter" @click="removeFilter('moveSizes', moveSize)" />
                  Move size: {{ moveSizes.find(el => el.id === moveSize).name }} </span>
              </span>
            </span>
            <span v-if="filters.deductedMoverWages" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="filters.deductedMoverWages = null" />
              Deducted mover wages
            </span>
            <button type="button" class="btn btn-secondary add-filters" @click="showFilters = true">
              <i class="fa fa-plus filter-icon" />
            </button>
          </div>
          <div class="col-1 d-flex justify-content-end">
            <div class="dropdown">
              <button class="btn btn-secondary sort-button sort-button-selected" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false"
              >
                <i v-if="selectedKey.length" class="fa pr-2" :class="[ascOrDesc === 'asc' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']" />
                <span v-if="selectedKey === 'created_at'">
                  Created at
                </span>
                <span v-else-if="selectedKey === 'move_date'">
                  Move date
                </span>
                <span v-else>
                  Sort by
                </span>
                <i class="fa fa-caret-down caret" />
              </button>
              <div class="dropdown-menu sort-dropdown dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <button class="dropdown-item sort-dropdown-item nav-link btn" @click.stop="sortBy('created_at')">
                  <span :class="[selectedKey === 'created_at' ? 'selected' : '']">
                    Created date
                  </span>
                  <span>
                    <i v-if="selectedKey === 'created_at'" class="fa" :class="[ascOrDesc === 'asc' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']" />
                  </span>
                </button>
                <button class="dropdown-item sort-dropdown-item nav-link btn" @click.stop="sortBy('move_date')">
                  <span :class="[selectedKey === 'move_date' ? 'selected' : '']">
                    Move date
                  </span>
                  <span>
                    <i v-if="selectedKey === 'move_date'" class="fa" :class="[ascOrDesc === 'asc' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <template v-if="loading">
          <vue-content-loading :width="800" :height="450">
            <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
          </vue-content-loading>
        </template>
        <template v-else-if="!totals.length">
          <span>There are no results.</span>
        </template>
        <template v-else>
          <div class="totals-table">
            <TotalsStatistics class="blocks" :meta="meta" :sums="sums" :averages="averages" />

            <div class="totals-wrapper blocks">
              <TotalsBlock
                class="pointer"
                v-for="total in totals"
                :key="total.job_id"
                :total="total"
                @openSidebar="openSidebar(total)"
              />
            </div>
          </div>

          <div class="row blocks">
            <div class="col-sm-6 mb-1 text-black-50 pl-0"
                 v-if="meta.total"
            >
              Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
            </div>
            <pagination class="col-sm-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
          </div>
        </template>
      </div>
    </div>


    <!-- Filters -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showFilters" @click.self="showFilters = false">
        <div v-if="showFilters" class="filters-side-modal flex flex-column">
          <div @click="showFilters = !showFilters" class="pointer">
            <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
          </div>
          <div>
            <p>
              Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.
            </p>
          </div>
          <div class="l-bg-white">
            <div class="row">
              <div class="col">
                <div class="row filters">
                  <div v-if="companies" class="col-12">
                    <div class="select-wrap">
                      <label>Company</label>
                      <key-multiselect v-model="filters.company"
                                       :options="companies"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :hide-selected="true"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div v-if="carriers" class="col-12">
                    <div class="select-wrap">
                      <label>Carriers</label>
                      <key-multiselect v-model="filters.carrier"
                                       :options="carriers"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :hide-selected="true"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div v-if="moveSizes" class="col-12">
                    <div class="select-wrap">
                      <label>Move sizes</label>
                      <key-multiselect v-model="filters.moveSizes"
                                       :options="moveSizes"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :hide-selected="true"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div v-if="moverNumbers" class="col-12">
                    <div class="select-wrap">
                      <label>Number of movers</label>
                      <key-multiselect v-model="filters.movers"
                                       :options="moverNumbers"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :hide-selected="true"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Sales Rep.</label>
                      <key-multiselect v-model="filters.clusterUser"
                                       :options="salesFilter"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :custom-label="customLabel"
                                       :hide-selected="true"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.full_name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Booked by</label>
                      <key-multiselect v-model="filters.bookedByUser"
                                       :options="salesFilter"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :custom-label="customLabel"
                                       :hide-selected="true"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.full_name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12" v-if="clusterUsersFilter && clusterUsersFilter.length">
                    <div class="select-wrap">
                      <label>User companies</label>
                      <simple-select v-model="filters.userCompanies"
                                     :options="clusterUsersFilter"
                                     :input-id="'user-companies-select'"
                                     placeholder="Select User"
                                     @input="search"
                                     track-by="id"
                                     label="full_name"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Move date</label>
                      <flat-pickr v-model="filters.move_date"
                                  :config="config"
                                  class="simple-select-input"
                                  placeholder="Select Move Date"
                                  name="date"
                                  @on-close="onMoveDateChange"
                      />
                      <span class="position-absolute clear-date" @click="clearMoveDateAndSearch"
                            v-if="filters.move_date"
                      >
                        <span class="mod-icon-clear" />
                        <span aria-hidden="true" class="sr-only">Clear</span>
                      </span>
                      <span class="position-absolute clear-date clear-date-transparent"
                            v-else
                      ><span class="mod-icon-rates-dark" /></span>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Booked date</label>
                      <flat-pickr v-model="filters.created_at"
                                  :config="config"
                                  class="simple-select-input"
                                  placeholder="Select Booked Date"
                                  name="date"
                                  @on-close="onCreatedAtChange"
                      />
                      <span class="position-absolute clear-date" @click="clearCreatedAtAndSearch"
                            v-if="filters.created_at"
                      >
                        <span class="mod-icon-clear" />
                        <span aria-hidden="true" class="sr-only">Clear</span>
                      </span>
                      <span class="position-absolute clear-date clear-date-transparent"
                            v-else
                      ><span class="mod-icon-rates-dark" /></span>
                    </div>
                  </div>
                  <div v-if="$_can('tags.show')" class="col-12">
                    <div class="select-wrap">
                      <label>Tags</label>
                      <key-multiselect
                        v-model="filters.tags"
                        :options="tags"
                        :multiple="true"
                        :clear-on-select="false"
                        :close-on-select="false"
                        track-by="id"
                        @input="search"
                        label="name"
                        class="w-100"
                      >
                        <template slot="tag" slot-scope="props">
                          <span class="multiselect__tag p-0 bg-transparent">
                            <span>
                              <tag-color

                                :color="props.option.color.name"
                                :name="props.option.name"
                              />
                            </span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <div class="d-flex align-items-center justify-content-between">
                              <span class="option__title">
                                {{ props.option.name }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col">
              <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters"
                      v-if="!clearFiltersButtonShouldBeDisabled"
              >
                Clear filters
              </button>
            </div>
            <div class="col">
              <button type="button" class="btn btn-primary text-white w-100" @click="saveFiltersModal = true"
                      v-if="!clearFiltersButtonShouldBeDisabled"
              >
                Save filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Totals sidebar -->
    <transition name="slide-fade">
      <div class="l-modal-mask-alt" v-if="openTotalsSidebar" @click.self="closeSidebar">
        <div v-if="openTotalsSidebar" class="totals-side-modal">
          <div @click="closeSidebar" class="heading pointer">
            <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />{{ selectedTotal.ref_id }}</h1>
            <span v-if="selectedTotal.payment_status_id === 3" class="ml-2 total-status-paid">
              paid
            </span>
          </div>
          <div class="section-name">
            <h2 class="totals-side-modal-h2">{{ selectedTotal.carrier.name }}</h2>
          </div>
          <div class="job-info d-flex pb-2">
            <div class="col d-flex job-info-left">
              <div class="rate pr-3">
                ${{ selectedTotal.rate }}
              </div>
              <div class="pr-3">
                <i class="fa fa-user totals-icon" />
                <span class="mover-number">
                  {{ selectedTotal.movers }}
                </span>
              </div>
              <div>
                <i class="fa fa-truck totals-icon" />
                <span class="truck-number">
                  {{ selectedTotal.trucks }}
                </span>
              </div>
            </div>
            <div class="col d-flex flex-column justify-content-end align-items-end job-info-right">
              <div>
                Min hours: {{ selectedTotal.minimum_hours }}h
              </div>
              <div class="d-flex">
                Transaction fee: {{ selectedTotal.charge_fee }}%
              </div>
            </div>
          </div>
          <div class="section-name">
            <h2 class="totals-side-modal-h2">job details</h2>
          </div>
          <div class="section-heading">
            <span>Total Job Time</span>
            <span>{{ selectedTotal.time }}</span>
          </div>
          <div class="section-content d-flex pb-2">
            <span>
              Total duration
            </span>
            <div>
              {{ selectedTotal.total_duration }}
            </div>
          </div>
          <div class="section-content d-flex pb-2">
            <span>
              Total breaks
            </span>
            <div v-if="selectedTotal.breaks && selectedTotal.breaks.length">
              {{ formatBreaks(selectedTotal.breaks) }}
            </div>
            <div v-else>
              -
            </div>
          </div>
          <div class="section-heading">
            <span>Price Breakdown</span>
          </div>
          <div class="section-content d-flex pb-2">
            <span>
              Base price
            </span>
            <div>
              $ {{ selectedTotal.base_price }}
            </div>
          </div>
          <div class="section-content d-flex pb-2">
            <span class="pointer"
                  @click="additionalExpensesToggle = !additionalExpensesToggle"
            >
              <i class="fa text-secondary"
                 aria-hidden="true"
                 :class="additionalExpensesToggle ? 'fa fa-caret-down' : 'fa fa-caret-right'"
              />
              <strong>
                Additional expenses
              </strong>
            </span>
            <div v-if="!loadingExpenses">
              <strong>$ {{ additionalExpensesSum ? additionalExpensesSum : '0' }}</strong>
            </div>
          </div>
          <template v-if="additionalExpensesToggle && !loadingExpenses">
            <div class="section-content flex-column" v-if="expenses">
              <div class="section-child pb-2"
                   v-for="expense in expenses" :key="expense.id"
              >
                <div>
                  <h5>{{ expense && expense.name }}</h5>
                </div>
                <div>
                  $ {{ expense.amount }}
                </div>
              </div>
            </div>
          </template>
          <div class="section-content d-flex pb-2">
            <span class="pointer"
                  @click="additionalDiscountsToggle = !additionalDiscountsToggle"
            >
              <i class="fa text-secondary"
                 aria-hidden="true"
                 :class="additionalDiscountsToggle ? 'fa fa-caret-down' : 'fa fa-caret-right'"
              />
              <strong>
                Discounts
              </strong>
            </span>
            <div v-if="!loadingDiscounts">
              <strong>- $ {{ selectedTotal.total_discounts }}</strong>
            </div>
          </div>
          <template v-if="additionalDiscountsToggle && !loadingDiscounts">
            <div class="section-content flex-column" v-if="discounts">
              <div class="section-child pb-2"
                   v-for="discount in discounts" :key="discount.id"
              >
                <div>
                  <h5>{{ discount && discount.name }} ({{ discount.type.name }})</h5>
                </div>
                <div>
                  <template v-if="discount.discount_unit_type_id === 1">
                    - $ {{ discount.amount }}
                  </template>
                  <template v-else-if="discount.discount_unit_type_id === 2">
                    - $ {{ discount.calculated_amount }} ({{ discount.amount }}%)
                  </template>
                </div>
              </div>
            </div>
          </template>
          <div class="section-heading">
            <span>Transactions</span>
          </div>
          <template v-if="selectedTotal.charges && selectedTotal.charges.length">
            <div v-for="(transaction, index) in selectedTotal.charges.filter(el => el.payment_type_id === 3)" :key="transaction.id">
              <div class="section-content d-flex pb-2">
                <div class="payment-type">
                  {{ transaction.payment_type.name }}
                  <div class="btn btn-link p-0 tippy-popup m-0"
                       @mouseover="$set(showTooltipTransactions, index, true)"
                       @mouseout="$set(showTooltipTransactions, index, false)"
                  >
                    <i class="fa fa-info-circle" />
                  </div>
                  <div class="popover popover-transaction tippy-info-popover"
                       v-if="showTooltipTransactions[index]"
                  >
                    <div>{{ transaction.date }}</div>
                    <div>
                      {{ transaction.payment_method.name }}
                    </div>
                    <div>{{ transaction.note }}</div>
                  </div>
                </div>
                <div>
                  $ {{ transaction.amount }}
                </div>
              </div>
            </div>
          </template>
          <div class="section-content d-flex pb-2">
            <span class="pointer"
                  @click="togglePayments = !togglePayments"
            >
              <i class="fa text-secondary"
                 aria-hidden="true"
                 :class="togglePayments ? 'fa fa-caret-down' : 'fa fa-caret-right'"
              />
              <strong>
                Payments
              </strong>
            </span>
            <div>
              <strong>$ {{ paymentsSum ? paymentsSum : '0' }}</strong>
            </div>
          </div>
          <template v-if="togglePayments">
            <div v-for="(transaction, index) in selectedTotal.charges.filter(el => el.payment_type_id === 1)" :key="transaction.id">
              <div class="section-content d-flex pb-2">
                <div class="payment-type">
                  {{ transaction.payment_type.name }}
                  <div class="btn btn-link p-0 tippy-popup m-0"
                       @mouseover="$set(showTooltipPayments, index, true)"
                       @mouseout="$set(showTooltipPayments, index, false)"
                  >
                    <i class="fa fa-info-circle totals-icon" />
                  </div>
                  <div class="popover popover-transaction tippy-info-popover"
                       v-if="showTooltipPayments[index]"
                  >
                    <div>{{ transaction.date }}</div>
                    <div>
                      {{ (transaction.payment_method_id === 4) ? '(**** ' + transaction.card.last4 + ')' : '' }}
                    </div>
                    <div>
                      {{ transaction.payment_method.name }}
                    </div>
                    <div>{{ transaction.note }}</div>
                  </div>
                </div>
                <div>
                  $ {{ transaction.amount }}
                </div>
              </div>
            </div>
          </template>
          <div class="section-content d-flex">
            <span class="pointer"
                  @click="toggleRefunds = !toggleRefunds"
            >
              <i class="fa text-secondary"
                 aria-hidden="true"
                 :class="toggleRefunds ? 'fa fa-caret-down' : 'fa fa-caret-right'"
              />
              <strong>
                Refunds
              </strong>
            </span>
            <div>
              <strong>$ {{ refundsSum ? refundsSum : '0' }}</strong>
            </div>
          </div>
          <template v-if="toggleRefunds">
            <div v-for="(transaction, index) in selectedTotal.charges.filter(el => el.payment_type_id === 2 || el.payment_type_id === 4)"
                 :key="index"
            >
              <div class="section-content d-flex pb-2">
                <div class="payment-type">
                  {{ transaction.payment_type.name }}
                  <div class="btn btn-link p-0 tippy-popup m-0"
                       @mouseover="$set(showTooltipRefunds, index, true)"
                       @mouseout="$set(showTooltipRefunds, index, false)"
                  >
                    <i class="fa fa-info-circle" />
                  </div>
                  <div class="popover popover-transaction tippy-info-popover"
                       v-if="showTooltipRefunds[index]"
                  >
                    <div>{{ transaction.date }}</div>
                    <div>
                      {{ (transaction.payment_method_id === 4) ? '(**** ' + transaction.card.last4 + ')' : '' }}
                    </div>
                    <div>
                      {{ transaction.payment_method.name }}
                    </div>
                    <div>{{ transaction.note }}</div>
                  </div>
                </div>
                <div>
                  $ {{ transaction.amount }}
                </div>
              </div>
            </div>
          </template>
          <hr />
          <div class="pricing-section d-flex">
            <span>
              <strong>
                Total price
              </strong>
            </span>
            <div>
              <strong>
                $ {{ selectedTotal.total_price }}
              </strong>
            </div>
          </div>
          <div class="pricing-section d-flex">
            <small class="text-secondary">
              Total fee
            </small>
            <small class="text-secondary">
              $ {{ selectedTotal.total_fee }}
            </small>
          </div>
          <div class="pricing-section d-flex">
            <span>
              Balance due
            </span>
            <div class="balance-due">
              $ {{ selectedTotal.remaining_price }}
            </div>
          </div>
          <div class="section-name mt-2">
            <h2 class="totals-side-modal-h2">mover details</h2>
          </div>
          <div class="section-heading">
            <span>Crew</span>
            <span @click.prevent="openWagesAndExtrasModal">
              <a href="#">
                Edit wages and extras
              </a>
            </span>
          </div>
          <div v-if="!loadingPayouts" class="pricing-section mb-4">
            <div v-for="payout in selectedTotal.payouts" :key="payout.user_id" class="row w-full">
              <div class="col-4">
                {{ payout.mover }}
                <span v-if="payout.foreman"
                      :class="'foreman-status-blue'"
                >F</span>
              </div>
              <div class="col-6">
                $ {{ payout.total_wage }} + $ {{ payout.extras }} extras + $ {{ payout.card_tips }} tips
              </div>
              <div class="col-2">
                <strong>
                  $ {{ payout.total_payout }}
                </strong>
              </div>
            </div>
          </div>
          <template v-if="selectedTotal.agreements && selectedTotal.agreements.length">
            <div class="section-name mt-2">
              <h2 class="totals-side-modal-h2">contracts</h2>
            </div>
            <div class="pricing-section mb-4">
              <div v-for="agreement in selectedTotal.agreements" :key="agreement.id" class="row w-full">
                <div class="col">
                  <i class="fa fa-file mt-2" />
                  <a :href="agreement.url" target="_blank">
                    {{ agreement.url.substring(agreement.url.lastIndexOf('/')+1) }}
                  </a>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </transition>

    <!-- Mover wage modal -->
    <MoverWagesModal
      v-if="wagesAndExtrasModal"
      @close="wagesAndExtrasModal = false"
      @updated="getPayouts"
      :id="selectedTotal.job_id"
      :payouts="selectedTotal.payouts"
    />

    <!-- Save filters modal -->
    <SaveFiltersModal
      v-if="saveFiltersModal"
      @close="saveFiltersModal = false"
      :filters="filters"
      :route="$route.path"
    />
  </div>
</template>

<script>
import toastr from 'toastr';
import { mapActions, mapMutations, mapState } from 'vuex';
import store from 'store';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from 'axios';
import * as moment from 'moment';
import FileDownload from 'js-file-download';
import Errors from '../../classes/Errors';
import Pagination from '../Pagination';
import TotalsBlock from './TotalsBlock';
import TotalsStatistics from './TotalsStatistics';
import MoverWagesModal from '../MoverWagesModal';
import TagColor from '../settings/Tags/TagColor';
import TotalsBlockMobile from './TotalsBlockMobile';
import TotalsStatisticMobile from './TotalsStatisticsMobile';
import SaveFiltersModal from '../SaveFiltersModal.vue';
import LoadFilterDropdown from '../LoadFilterDropdown.vue';

export default {
  name: 'Totals',
  components: {
    LoadFilterDropdown,
    SaveFiltersModal,
    TotalsStatisticMobile,
    TotalsBlockMobile,
    TagColor,
    Pagination,
    TotalsBlock,
    TotalsStatistics,
    MoverWagesModal,
    flatPickr,
  },
  data: () => ({
    additionalDiscountsSum: null,
    additionalDiscountsToggle: false,
    additionalExpensesSum: null,
    additionalExpensesToggle: false,
    averages: [],
    cancelToken: '',
    companyId: store.get('dispatchUser').company_id,
    config: {
      dateFormat: 'm/j/Y',
      mode: 'range',
    },
    discounts: [],
    errors: new Errors(),
    expanded: false,
    expenses: [],
    filters: {
      bookedByUser: [],
      clusterUser: [],
      company: [],
      createdAtEnd: '',
      createdAtStart: '',
      created_at: '',
      carrier: [],
      moveDateEnd: moment()
        .subtract(1, 'month')
        .endOf('month')
        .format('M/D/YYYY'),
      moveDateStart: moment()
        .subtract(1, 'month')
        .startOf('month')
        .format('M/D/YYYY'),
      move_date: `${moment()
        .subtract(1, 'month')
        .startOf('month')
        .format('M/D/YYYY')} to ${moment()
        .subtract(1, 'month')
        .endOf('month')
        .format('M/D/YYYY')}`,
      movers: [],
      moveSizes: [],
      sortKey: '',
      sortOrder: '',
      userCompanies: '',
      tags: [],
      deductedMoverWages: 0,
    },
    filterTemplatesInitialized: false,
    hasDefaultFilterTemplate: true,
    inProgress: false,
    loading: false,
    loadingCharges: false,
    loadingDiscounts: false,
    loadingExpenses: false,
    loadingPayouts: false,
    meta: [],
    mobileMenuState: 'listOfJobs',
    moverNumbers: [],
    openTotalsSidebar: false,
    page: 1,
    paymentsSum: null,
    q: '',
    refundsSum: null,
    saveFiltersModal: false,
    selectedKey: '',
    selectedTotal: {},
    showFilters: false,
    showTooltipPayments: [],
    showTooltipRefunds: [],
    showTooltipTransactions: [],
    source: '',
    sums: [],
    tags: [],
    togglePayments: false,
    toggleRefunds: false,
    totals: [],
    wagesAndExtrasModal: false,
  }),
  computed: {
    ...mapState({
      carriers: state => state.carriers.carriers.data,
      clusterUsersFilter: state => state.clusterUsers.clusterUsers,
      companies: state => state.companies.companies.data,
      filtersLoaded: state => state.guard.filtersLoaded,
      moveSizes: state => state.values.moveSizes,
      salesFilter: state => state.clusterUsers.salesFilter,
    }),
    ascOrDesc() {
      return this.filters.sortOrder === 'asc' ? 'asc' : 'desc';
    },
    clearFiltersButtonShouldBeDisabled() {
      return (
        !this.filters.carrier.length &&
        !this.filters.clusterUser.length &&
        !this.filters.bookedByUser.length &&
        !this.filters.company.length &&
        !this.filters.move_date &&
        !this.filters.userCompanies &&
        !this.filters.movers &&
        !this.filters.moveSizes &&
        !this.filters.created_at
      );
    },
  },
  watch: {
    expenses() {
      const exp = this.expenses;
      if (exp.length) {
        if (exp.map(el => parseFloat(el.amount.replace(/,/g, ''))).length) {
          this.additionalExpensesSum = exp
            .map(el => parseFloat(el.amount.replace(/,/g, '')))
            .reduce((carrier, current) => carrier + current)
            .toFixed(2);
        }
      }
    },
    filterTemplatesInitialized() {
      if (!this.hasDefaultFilterTemplate) {
        if (Object.keys(this.$route.query).length !== 0) {
          this.setFilters(this.$route.query);
        }
      }
      this.filter();
    },
  },
  created() {
    this.cancelToken = axios.CancelToken;
    this.source = this.cancelToken.source();
  },
  mounted() {
    this.getMoverNumbers();
    this.getTags();
  },
  methods: {
    ...mapActions(['getTotals']),
    ...mapMutations(['setTotals']),
    formatToMiliseconds(h, m, s) {
      return (h * 60 * 60 + m * 60 + s) * 10;
    },
    openWagesAndExtrasModal() {
      this.wagesAndExtrasModal = !this.wagesAndExtrasModal;
    },
    formatBreaks(breaks) {
      if (breaks.length) {
        let breaksSum = 0;

        breaks.forEach(tempBreak => {
          let totalTo = tempBreak.to.split(':');
          totalTo = this.formatToMiliseconds(...totalTo);

          let totalFrom = tempBreak.from.split(':');
          totalFrom = this.formatToMiliseconds(...totalFrom);

          tempBreak.total = totalTo - totalFrom;

          breaksSum += tempBreak.total;
        });

        return moment.utc(breaksSum).format('HH:mm');
      }

      return 0;
    },
    loadFilters(filtersData) {
      this.filters = Object.assign(filtersData);
      this.filter();
    },
    setFilterTemplatesInitialized(hasDefault) {
      this.hasDefaultFilterTemplate = hasDefault;
      this.filterTemplatesInitialized = true;
    },
    markAsPaid() {
      const query = `${this.getQuery()}&paginated=false`;
      axios
        .get(`/totals/paid?${query}`)
        .then(() => {
          toastr.success('Jobs marked as paid');
        })
        .catch(() => {});
    },
    setDeductedMoverWagesFilter(value) {
      this.$set(this.filters, 'deductedMoverWages', value);
      this.filter();
    },
    openSidebar(total) {
      this.selectedTotal = total;
      this.loadingCharges = true;
      this.loadingDiscounts = true;
      this.loadingExpenses = true;
      this.loadingPayouts = true;
      this.getCharges(total.job_id);
      this.getExpenses(total.job_id);
      this.getDiscounts(total.job_id);
      this.getPayouts(total.job_id);
      this.openTotalsSidebar = !this.openTotalsSidebar;
    },
    getMoverNumbers() {
      axios
        .get('/values/cluster/mover-numbers')
        .then(res => {
          this.moverNumbers = res.data.data;
        })
        .catch(() => {});
    },
    getTags() {
      axios
        .get('/companies/tags/list?paginated=false')
        .then(res => {
          this.tags = res.data.data;
        })
        .catch(() => {});
    },
    closeSidebar() {
      this.openTotalsSidebar = false;
      this.expenses = [];
      this.discounts = [];
      this.additionalExpensesSum = 0;
      this.additionalDiscountsSum = 0;
    },
    getExpenses(id) {
      axios
        .get(`/jobs/${id}/job-expenses`)
        .then(res => {
          this.expenses = res.data.data;
          this.loadingExpenses = false;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getCharges(id) {
      axios
        .get(`/charges/job/${id}`)
        .then(res => {
          this.selectedTotal.charges = res.data.data;
          const payments = this.selectedTotal.charges.filter(el => el.payment_type_id === 1);
          if (payments.length) {
            if (payments.map(el => parseFloat(el.amount.replace(/,/g, ''))).length > 0) {
              this.paymentsSum = payments
                .map(el => parseFloat(el.amount.replace(/,/g, '')))
                .reduce((carrier, current) => carrier + current)
                .toFixed(2);
            }
          }
          const refunds = this.selectedTotal.charges.filter(
            el => el.payment_type_id === 2 || el.payment_type_id === 4,
          );
          if (refunds.length) {
            if (refunds.map(el => parseFloat(el.amount.replace(/,/g, ''))).length > 0) {
              this.refundsSum = refunds
                .map(el => parseFloat(el.amount.replace(/,/g, '')))
                .reduce((carrier, current) => carrier + current)
                .toFixed(2);
            }
          }
          this.loadingCharges = false;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getDiscounts(id) {
      axios.get(`/jobs/${id}/job-discounts`).then(res => {
        this.discounts = res.data.data;
        this.loadingDiscounts = false;
      });
    },
    getPayouts(id) {
      axios.get(`/jobs/${id}/payouts`).then(res => {
        this.$set(this.selectedTotal, 'payouts', res.data.data);
        this.loadingPayouts = false;
      });
    },
    customLabel(option) {
      return (
        `${option.first_name === undefined ? '' : option.first_name}` +
        ` ${option.last_name === undefined ? '' : option.last_name}`
      );
    },
    setFilters(query) {
      this.filters = Object.assign(
        {
          carrier: query.carrier_id ? query.carrier_id.split(',').map(i => Number(i)) : [],
          company: query.company_id ? query.company_id.split(',').map(i => Number(i)) : [],
          moveDateStart: query.date_from ? query.date_from.toString() : this.filters.moveDateStart,
          moveDateEnd: query.date_to ? query.date_to.toString() : this.filters.moveDateEnd,
          move_date:
            query.date_from && query.date_to
              ? `${query.date_from.toString()} to ${query.date_to.toString()}`
              : `${this.filters.moveDateStart} to ${this.filters.moveDateEnd}`,
          createdAtStart: query.created_from.toString(),
          createdAtEnd: query.created_to.toString(),
          created_at:
            query.created_from && query.created_to
              ? `${query.created_from.toString()} to ${query.created_from.toString()}`
              : '',
          clusterUser: query.cluster_user_id
            ? query.cluster_user_id.split(',').map(i => Number(i))
            : [],
          bookedByUser: query.booked_by_user_id
            ? query.booked_by_user_id.split(',').map(i => Number(i))
            : [],
          movers: query.movers ? query.movers.split(',').map(i => Number(i)) : [],
          moveSizes: query.move_size_id ? query.move_size_id.split(',').map(i => Number(i)) : [],
          tags: query.tag_id ? query.tag_id.split(',').map(i => Number(i)) : [],
          sortKey: query.sort,
          sortOrder: query.order,
          userCompanies: query.user_companies ? parseInt(query.user_companies, 10) : '',
          deductedMoverWages: query.deducted_mover_wages
            ? parseInt(query.deducted_mover_wages, 10)
            : 0,
        },
        {},
      );
      this.q = query.q.toString();
      this.page = query.page;
      this.selectedKey = this.filters.sortKey;
    },
    changePage(pageNum) {
      this.page = pageNum;
      this.filter();
    },
    getTotalsFiltered(query) {
      this.loading = true;
      this.inProgress = true;
      axios
        .get(`totals?${query}`, { cancelToken: this.source.token })
        .then(res => {
          this.averages = res.data.avg;
          this.meta = res.data.meta;
          this.sums = res.data.sums;
          this.totals = res.data.data;
        })
        .finally(() => {
          this.loading = false;
          this.inProgress = false;
        })
        .catch(err => {
          if (axios.isCancel(err)) {
            this.loading = true;
          }
        });
    },
    searchText(e) {
      this.page = 1;
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.filter();
        }, 500);
      }
    },
    search() {
      this.page = 1;
      this.filter();
    },
    downloadReport() {
      const query = `${this.getQuery()}&paginated=false`;
      axios({
        url: `totals/report?${query}`,
        method: 'GET',
        responseType: 'blob',
      }).then(response => {
        const fileName = `Totals ${moment().format('YYYY-MM-DD hhmmss')}.csv`;

        FileDownload(response.data, fileName);
      });
    },
    filter() {
      const query = this.getQuery();
      if (!this.inProgress) {
        this.getTotalsFiltered(query);
        if (this.$_checkProperties(this.filters)) {
          this.$router.push(`/reports/totals?${query}`);
        } else {
          this.$router.push(`/reports/totals`);
        }
      } else {
        // If there is a request in progress, cancel it, and try again with other request
        this.source.cancel('Operation canceled by the user.');
        // Set axios cancel token and source to new values, so you can repeat request
        this.cancelToken = axios.CancelToken;
        this.source = this.cancelToken.source();
        this.inProgress = false;
        this.getTotalsFiltered(query);
        if (this.$_checkProperties(this.filters)) {
          this.$router.push(`/reports/totals?${query}`);
        } else {
          this.$router.push(`/reports/totals`);
        }
      }
    },
    getQuery() {
      return (
        `page=${this.page}&carrier_id=${this.filters.carrier}&company_id=${
          this.filters.company
        }&date_from=${this.filters.moveDateStart}` +
        `&date_to=${this.filters.moveDateEnd}&created_from=${this.filters.createdAtStart}` +
        `&user_companies=${this.filters.userCompanies}` +
        `&movers=${this.filters.movers ? this.filters.movers : []}` +
        `&move_size_id=${this.filters.moveSizes ? this.filters.moveSizes : []}` +
        `&created_to=${this.filters.createdAtEnd}&cluster_user_id=${
          this.filters.clusterUser ? this.filters.clusterUser : []
        }&booked_by_user_id=${
          this.filters.bookedByUser ? this.filters.bookedByUser : []
        }&q=${encodeURIComponent(this.q)}` +
        `&sort=${this.filters.sortKey}&order=${this.filters.sortOrder}` +
        `&tag_id=${this.filters.tags}&deducted_mover_wages=${
          this.filters.deductedMoverWages ? this.filters.deductedMoverWages : 0
        }`
      );
    },
    clearFilters() {
      this.filters = Object.assign(
        {
          carrier: [],
          bookedByUser: [],
          clusterUser: [],
          company: [],
          created_at: '',
          createdAtStart: '',
          createdAtEnd: '',
          move_date: '',
          moveDateStart: '',
          moveDateEnd: '',
          movers: [],
          moveSizes: [],
          tags: [],
          sortKey: '',
          sortOrder: '',
          userCompanies: '',
        },
        {},
      );
      this.filter();
      this.showFilters = false;
    },
    clearSearch() {
      this.q = '';
      this.filter();
    },
    clearMoveDateAndSearch() {
      this.filters.move_date = '';
      this.filters.moveDateStart = '';
      this.filters.moveDateEnd = '';
      this.page = 1;
      this.filter();
    },
    onMoveDateChange(selectedDates) {
      this.filters.moveDateStart = selectedDates[0]
        ? selectedDates[0].toLocaleDateString('en-US')
        : '';
      this.filters.moveDateEnd = selectedDates[1]
        ? selectedDates[1].toLocaleDateString('en-US')
        : '';
      this.search();
    },
    clearCreatedAtAndSearch() {
      this.filters.created_at = '';
      this.filters.createdAtStart = '';
      this.filters.createdAtEnd = '';
      this.page = 1;
      this.filter();
    },
    onCreatedAtChange(selectedDates) {
      this.filters.createdAtStart = selectedDates[0]
        ? selectedDates[0].toLocaleDateString('en-US')
        : '';
      this.filters.createdAtEnd = selectedDates[1]
        ? selectedDates[1].toLocaleDateString('en-US')
        : '';
      this.search();
    },
    sortBy(key) {
      this.selectedKey = key;
      this.$set(this.filters, 'sortKey', key);
      this.$set(this.filters, 'sortOrder', this.filters.sortOrder === 'desc' ? 'asc' : 'desc');
      this.filter();
    },
    removeFilter(model, id) {
      if (id) {
        this.filters[model] = this.filters[model].filter(element => element !== id);
      }
      if (model === 'move_date') {
        this.filters.move_date = '';
        this.filters.moveDateStart = '';
        this.filters.moveDateEnd = '';
      }
      if (model === 'created_at') {
        this.filters.created_at = '';
        this.filters.createdAtStart = '';
        this.filters.createdAtEnd = '';
      }
      this.search();
    },
  },
};
</script>
<style lang="scss" scoped>
.desktop-list {
  display: block;
}

.mobile-list {
  display: none;
}
.totals-wrapper {
  height: calc(80vh - 112px);
  overflow: auto;
}
.input-group {
  width: 35%;
}
.totals-side-modal {
  .heading {
    padding: 20px 0 0 10px;
  }
  .section-name {
    background: #4c5669;
  }
  .job-info {
    :first-child {
      align-items: baseline;
      .rate {
        font-weight: bold;
        font-size: 18px;
        color: #4c5669;
      }
    }
    .job-info-left {
      padding: 10px 0 0 13px;
      max-height: 40px;
      align-items: baseline;
    }
    .job-info-right {
      padding: 10px 13px 10px 0;
    }
  }
  .section-heading {
    background: #f3f4f5;
    padding: 13px;
    display: flex;
    justify-content: space-between;
    & > span {
      font-weight: bold;
      font-size: 14px;
      color: #212529;
    }
  }
  .section-content {
    padding: 13px;
    display: flex;
    justify-content: space-between;
    .section-child {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
    }
    .payment-type {
      position: relative;
      width: 40%;
    }
  }
}
.totals-side-modal-h2 {
  font-size: 18px;
  text-transform: uppercase;
  color: #ffffff;
  padding-left: 13px;
}
.totals-side-modal h5 {
  opacity: 1;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4c5669;
}
.totals-icon {
  color: #c0c6cc;
  font-size: 18px;
}
.truck-number,
.mover-number {
  font-size: 16px;
}
.balance-due {
  color: #ff2929;
}
.pricing-section {
  padding: 4px 13px 2px 13px;
  justify-content: space-between;
}

@media screen and (max-width: 992px) {
  .mobile-list {
    display: block;
  }

  .desktop-list {
    display: none;
  }

  .blocks {
    margin: 20px 0 20px 0;
  }

  .mobile-menu-link {
    width: 50%;
    color: #6c6c6c;
    text-align: center;
    font-weight: 400;
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 5px;
  }

  .mobile-menu-link-active {
    color: #0f47e2;
    border-bottom: 2px solid #0f47e2;
  }

  .total-table-title {
    white-space: nowrap;
    font-size: 0.67rem;
    font-weight: 500;
    color: black;
    text-align: right;
  }

  .totals-side-modal {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reports/Totals.vue